import { UnborderCollapse } from 'aa_common/front-end/components'
import { ifElse } from 'aa_common/front-end/helpers'
import { LEDGER_PURPOSE, RETIREMENT_DEPRECIATION_ENDED_METHOD } from 'common/constants'
import { getNs } from 'common/i18n-config'
import { AutoCompleteSelect } from 'components/molecules'
import { isEqual } from 'lodash'
import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { selectAssetItemData } from 'store/asset/selectors'
import { selectMasterData } from 'store/masterData/selectors'
import { selectLedgerSettingList } from 'store/settings/ledgerSetting/selectors'

import { Group } from '../../events/styles'
import { convertDataLedgerSettingHelper } from '../../helper/convert-data-ledger-setting.helper'
import { renderLedgerSettingFields } from '../../helper/render-ledger-setting-fields'
import { contentItemWidth, itemWidth } from '../Form'
import { nonDepreciationMethodLength } from '../helper'

const { Item } = UnborderCollapse
const { t } = getNs('components/organisms/assets/asset-retirement-form')
export const DepreciationEndedMethods = ({
  isEditMode,
  isBulkChangeEvent,
  isSmallAmountDepreciableAsset,
  isRetirementDepreciationEndedMethod,
  isShowRetirementDepreciationEndedMethodField,
}: Props) => {
  const ledgerSettings = useSelector(selectLedgerSettingList, isEqual)
  const masterData = useSelector(selectMasterData, isEqual)
  const assetItem = useSelector(selectAssetItemData, isEqual)

  const endedMethodIndex = -1
  const assetLedgers = assetItem?.fixed_asset_ledgers
  const assetLedgerLength = assetLedgers?.length
  const areAllLedgersNonDepreciationMethod =
    assetLedgers && nonDepreciationMethodLength(assetLedgers) === assetLedgerLength
  const hasBothTaxAndAccountingLedgers =
    ledgerSettings?.some(element => element?.ledger_purpose === LEDGER_PURPOSE.TAX) &&
    ledgerSettings?.some(element => element?.ledger_purpose === LEDGER_PURPOSE.ACCOUNTING)

  const retirementDepreciationEndedMethods = useMemo(() => {
    if (!masterData) return []

    return masterData.retirement_depreciation_ended_method.filter(
      item => item.code !== RETIREMENT_DEPRECIATION_ENDED_METHOD.SELECT_WHEN_SELL_AND_RETIREMENT
    )
  }, [masterData])

  const retirementDepreciationEndedMethodItems = retirementDepreciationEndedMethods.filter(
    item => item.code !== RETIREMENT_DEPRECIATION_ENDED_METHOD.END_OF_DEPRECIATION
  )

  return (
    <Item
      required={
        isBulkChangeEvent ||
        (isRetirementDepreciationEndedMethod && !(isSmallAmountDepreciableAsset || areAllLedgersNonDepreciationMethod))
      }
      label={t('select_depreciation_method')}
      contentWidth={contentItemWidth}
      style={ifElse(
        !isBulkChangeEvent,
        {
          width: itemWidth,
          whiteSpace: 'pre-line',
          alignItems: 'center',
          paddingBottom: 0,
        },
        {}
      )}
      requiredClassName={ifElse(!isBulkChangeEvent, 'retire-required-label', '')}
    >
      <Group>
        {isBulkChangeEvent && isShowRetirementDepreciationEndedMethodField && (
          <AutoCompleteSelect
            name="retirement_fixed_asset_ledger_requests[0].retirement_depreciation_ended_method"
            wrapperStyle={{ width: 240 }}
            items={retirementDepreciationEndedMethodItems}
            valueField="code"
            textField="name_jp"
            allowClear={false}
          />
        )}

        {!isBulkChangeEvent &&
          renderLedgerSettingFields({
            ledgerSettings,
            endedMethodIndex,
            convertDataLedgerSettingHelper,
            assetItem,
            isEditMode,
            retirementDepreciationEndedMethods,
            hasBothTaxAndAccountingLedgers,
            isRetirementEvent: true,
          })}
      </Group>
    </Item>
  )
}

type Props = {
  isEditMode: boolean
  isBulkChangeEvent?: boolean
  isSmallAmountDepreciableAsset: boolean | null
  isRetirementDepreciationEndedMethod?: boolean
  isShowRetirementDepreciationEndedMethodField?: boolean
}
